import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("hn_token")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const applyAuth = (data) => {
    localStorage.setItem("hn_token", data.token);
    setUser(data.user);
  };

  const login = async (username, password) => applyAuth((await api.post("/auth/login", { username, password })).data);
  const register = async (form) => applyAuth((await api.post("/auth/register", form)).data);
  const logout = () => {
    localStorage.removeItem("hn_token");
    localStorage.removeItem("hn_business");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
